import type { LocalizedString } from "../Locale.js";
import { Locale } from "../Locale.js";

export const catalogueNameMap: LocalizedString = {
	[Locale.cs]: "Katalog",
	[Locale.en]: "Catalogue",
	[Locale.sk]: "Katalóg",
};
